module.exports = __webpack_public_path__ + "img/link-banner-pl.516a3f43.png";